/* eslint-disable import/prefer-default-export */
import React, { useCallback, useState } from 'react'

import clsx from 'clsx'
import s from './Vote.module.css'

import { UpVote } from './UpVote'
import { DownVote } from './DownVote'

export function Vote({ collectionId, listingId, myVote }) {
  const [inProgress, setInProgress] = useState(false)

  const [myVoteValue, setMyVoteValue] = useState(myVote)

  const handleUpvote = useCallback(async () => {
    if (inProgress) {
      return
    }

    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      const res = await fetch(`/api/v3/listing_collections/${collectionId}/upvote`, {
        headers: {
          'API_TOKEN': apiToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body: JSON.stringify({
          listing_id: listingId,
        }),
      })

      const jsonRes = await res.json()

      const myVote = jsonRes?.votes?.find((vote) => vote.listing_id === listingId)?.my_vote

      if (myVote) {
        setMyVoteValue(myVote)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setInProgress(false)
    }
  }, [collectionId, listingId])

  const handleDownVote = useCallback(async () => {
    if (inProgress) {
      return
    }

    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      const res = await fetch(`/api/v3/listing_collections/${collectionId}/downvote`, {
        headers: {
          'API_TOKEN': apiToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body: JSON.stringify({
          listing_id: listingId,
        }),
      })

      const jsonRes = await res.json()

      const myVote = jsonRes?.votes?.find((vote) => vote.listing_id === listingId)?.my_vote

      if (myVote) {
        setMyVoteValue(myVote)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setInProgress(false)
    }
  }, [collectionId, listingId, inProgress])

  return (
    <div className={s.root}>
      <DownVote onClick={handleDownVote} className={clsx(s.icon, myVoteValue === 'downvote' && s.iconActive)} />{' '}
      <UpVote onClick={handleUpvote} className={clsx(s.icon, myVoteValue === 'upvote' && s.iconActive)} />
    </div>
  )
}
